import {Box, Field, Flex, Title} from 'exsportia-components'
import {Formik} from 'formik'
import {FC, useMemo, useState} from 'react'

import {Button} from '../../ui/components/button/button'
import {PhoneLoginProgress} from '../../ui/components/phone-login-progress/phone-login-progress'
import {useLocale} from '../../utils/i18n'

type PhoneLoginPhotoStepProps = {
  onFinish: (avatar: string | null) => void
  onSkip: () => void
  isLoading?: boolean
  onBack?: () => void
  initialAvatar?: string | null
}

export const PhoneLoginPhotoStep: FC<PhoneLoginPhotoStepProps> = ({onFinish, onSkip, onBack, isLoading = false, initialAvatar}) => {
  const {l} = useLocale()
  const [avatar, setAvatarValue] = useState<string | null>(initialAvatar || null)

  const setAvatar = (value: string[]) => {
    setAvatarValue(value[0])
  }

  const selectedAvatar = useMemo(() => avatar || null, [avatar])

  return (
    <Formik
      initialValues={{avatar: ''}}
      onSubmit={(_values, _helpers) => {
        _helpers.setSubmitting(false)
      }}
    >
      <Box pb={'24px'}>
        <PhoneLoginProgress currentStep={4} />
        <Flex
          justifyContent='space-between'
          alignItems='center'
          mb='8px'
        >
          <Title
            text={l('chooseProfileImage')}
            styleType='h2'
          />
          <Button
            type='flat_short'
            onClick={onSkip}
          >
            {l('skip', {defaultMessage: 'Skip'})}
          </Button>
        </Flex>

        <Field
          fieldType='media'
          setFieldValue={(_, value) => setAvatar(value as string[])}
          input={{
            id: 'avatar',
            name: 'avatar',
            // @ts-ignore
            compressedMaxSize: 0.5,
            compressedMaxWidthOrHeight: 800,
            settings: {
              cropSize: {width: 300, height: 300},
            },
          }}
        />

        {selectedAvatar && (
          <Flex
            mt='16px'
            overflow='hidden'
            borderRadius='16px'
          >
            <img
              src={selectedAvatar}
              style={{width: '100%'}}
              alt='Avatar Preview'
            />
          </Flex>
        )}

        <Flex mt='16px' gap='16px'>
          {onBack && (
            <Box style={{flex: 1}}>
              <Button
                type='secondary'
                onClick={onBack}
              >
                {l('back', {defaultMessage: 'Back', caseAction: 'capitalize'})}
              </Button>
            </Box>
          )}
          <Box style={{flex: 1}}>
            <Button
              isLoading={isLoading}
              onClick={() => onFinish(avatar)}
            >
              {l('finish')}
            </Button>
          </Box>
        </Flex>
      </Box>
    </Formik>
  )
}
